import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  Button
} from 'reactstrap';
import WeekdaySelector from '../../../../../components/Inputs/WeekDaySelector';

const PauseModal = ({ isOpen, toggle, pauses, pauseOptions, onSave }) => {
  const [selectedPause, setSelectedPause] = useState(
    pauses && pauses.length > 0
      ? {
          pauseName: pauses[0].label,
          pauseValue: pauses[0].value
        }
      : null
  );
  const [reference, setReference] = useState('ENTRY');
  const [interval, setInterval] = useState(0);
  const [duration, setDuration] = useState(1);
  const [toleranceTime, setToleranceTime] = useState(0);
  const [enableUnpauseCheck, setEnableUnpauseCheck] = useState(false);
  const [selectedDays, setSelectedDays] = useState({
    sun: false,
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false
  });

  useEffect(() => {
    if (pauses.length > 0) {
      setSelectedPause({
        pauseName: pauses[0].label,
        pauseValue: pauses[0].value
      });
    }
  }, [pauses]);

  const handleDaysChange = (days) => {
    setSelectedDays(days);
  };

  const handleSave = () => {
    const newPause = {
      pauseId: selectedPause?.pauseValue,
      pauseName: selectedPause?.pauseName,
      intervalReference: reference,
      triggerInterval: interval,
      duration: duration,
      enableUnpauseCheck: enableUnpauseCheck,
      toleranceTime: toleranceTime,
      monday: selectedDays.mon,
      tuesday: selectedDays.tue,
      wednesday: selectedDays.wed,
      thursday: selectedDays.thu,
      friday: selectedDays.fri,
      saturday: selectedDays.sat,
      sunday: selectedDays.sun
    };
    onSave(newPause);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true}>
      <ModalHeader toggle={toggle}>Pausa automática</ModalHeader>
      <ModalBody>
        <Row>
          <Col md="12">
            <h5>Pausa</h5>
            <Input
              type="select"
              name="pauseId"
              onChange={(e) => {
                const newPause = JSON.parse(e.target.value);
                setSelectedPause(newPause);
              }}
              value={selectedPause ? JSON.stringify(selectedPause) : ''}
            >
              {pauses.map((pause, key) => {
                return (
                  <option
                    key={key}
                    value={JSON.stringify({
                      pauseName: pause.label,
                      pauseValue: pause.value
                    })}
                  >
                    {pause.label}
                  </option>
                );
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          <Col md="8">
            <h5>Referência</h5>
            <Input
              type="select"
              name="intervalReference"
              onChange={(e) => {
                setReference(e.target.value);
              }}
            >
              {pauseOptions.map((pause, index) => {
                return (
                  <option key={index} value={pause.value}>
                    {pause.label}
                  </option>
                );
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          <Col md="12">
            <h5>Intervalo para acionamento(Minutos)</h5>
            <Input
              type="number"
              name="intervalReference"
              onChange={(e) => setInterval(e.target.value)}
              defaultValue={0}
              min={0}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          <Col md="12">
            <h5>Duração(Minutos)</h5>
            <Input
              type="number"
              name="duration"
              onChange={(e) => setDuration(e.target.value)}
              defaultValue={0}
              min={1}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          <Col md="12">
            <label className="form-control-label">
              Tempo de Tolerância* (Segundos)
            </label>
            <Input
              type="number"
              disabled={!enableUnpauseCheck}
              name="toleranceTime"
              onChange={(e) => setToleranceTime(e.target.value)}
              value={toleranceTime}
              defaultValue={0}
              min={0}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: '1rem' }}>
          <Col md="12">
            <WeekdaySelector onChange={handleDaysChange} />
          </Col>
        </Row>

        <Row className="ml-1">
          <Col md="12">
            <label className="form-control-label">
              <Input
                type="checkbox"
                onChange={(e) => {
                  setEnableUnpauseCheck(e.target.checked);
                  setToleranceTime(0);
                }}
                checked={enableUnpauseCheck}
              />
              Habilitar bloqueio da remoção da pausa após horario
            </label>
          </Col>
        </Row>
        <Row className="mt-3 ml-1">
          <Button color="primary" onClick={handleSave}>
            Salvar
          </Button>

          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default PauseModal;
